import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetUniqueUrlJsonRequest, IGetUniqueUrlJsonResponse } from '@/Module/Grade/Model/ApiModel';
import GradeService from '@/Module/Grade/Service/GradeService';

export const getGradeJsonAction = createAsyncThunk<IGetUniqueUrlJsonResponse, IGetUniqueUrlJsonRequest>(
  'grade/getGradeJson',
  async (req, { signal, rejectWithValue }) => {
    return GradeService.getUniqueUrlJson(req, signal)
      .then(
        ({
          data: {
            data: { data },
          },
        }) => {
          if (!data?.meta_data) return {};
          try {
            return JSON.parse(data.meta_data);
          } catch (e) {
            return {};
          }
        },
      )
      .catch(rejectWithValue);
  },
);
